import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../core/authentication.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as passwordHash from "js-sha512";
import { ErrorStateMatcher } from "@angular/material/core";
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
  FormGroup,
  FormBuilder,
} from "@angular/forms";
import { MustMatch } from "./must-match.validator";
import { HttpErrorResponse } from "@angular/common/http";
import { SharedService } from "../shared/shared.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  changepasswordForm: FormGroup;
  verificationCode: string = null;
  passwordHide = true;
  confirmPasswordHide = true;
  errorMsg: any;
  showError: boolean = false;
  hideForm = false;
  loading: boolean = false;
  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private translationService: TranslateService
  ) {
    // this.route.queryParams.subscribe((params) => {
    //   this.verificationCode = params["verificationCode"];
    // });
  }

  ngOnInit() {
    this.route.data.subscribe((data) => {
      if (data.error) {
        if (!data?.length) {
          this.router.navigate(["/login"]);
          return;
        }

        this.errorMsg = data.data;
        this.hideForm = true;
        this.showError = true;
      }

      // this.errorMsg = error.error.errors;
      // this.hideForm = true;
      // this.showError = true;
    });

    // this.route.params.subscribe((params) => {
    //   this.verificationCode = params["verificationCode"];
    // });

    // if ( this.verificationCode ) {
    //   this.verifyCode();
    // } else {
    //   this.router.navigate(["/login"]);
    // }

    let passwordregex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,15}$/;
    this.changepasswordForm = this.fb.group(
      {
        password: [
          "",
          [
            Validators.required,
            Validators.pattern(passwordregex),
            Validators.minLength(8),
          ],
        ],
        confirmPassword: ["", [Validators.required]],
      },
      {
        validator: MustMatch("password", "confirmPassword"),
      }
    );
  }

  verifyCode() {
    this.authService.codeVerification(this.verificationCode).subscribe(
      (res: any) => {},
      (error: HttpErrorResponse) => {
        this.errorMsg = error.error.errors;
        this.hideForm = true;
        this.showError = true;
      }
      // (error: HttpErrorResponse) => {
      //   this.handleError(error)
      // }
    );
  }

  changePasswordSubmit() {
    if (this.changepasswordForm.invalid) {
      return;
    }
    this.loading = true;
    this.showError = false;
    let hashedPassword = passwordHash.sha512(
      this.changepasswordForm.value.password
    );
    this.authService.resetPassword(hashedPassword).subscribe(
      (res: any) => {
        this.loading = false;
        this.translationService
          .get("Password changed successfully")
          .subscribe((text: string) => {
            this.sharedService.showMessage(text, "success");
          });
        this.router.navigate(["/"]);
      },
      (error: HttpErrorResponse) => {
        this.loading = false;
        this.showError = true;
        this.errorMsg = error.error.errors.messages[0];
      }
      // (error: HttpErrorResponse) => {
      //   this.handleError(error)
      // }
    );
  }

  handleError(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = error.error.message;
      this.sharedService.showErrorMessage(errorMessage, "single");
    } else {
      // server-side error

      if (error.status == 422) {
        let values = [];
        for (let key in error.error.errors.messages) {
          values.push(error.error.errors.messages[key]);
        }
        this.sharedService.showMultipleErrors(values, "multi");
      } else {
        if (typeof error.error.errors == "object") {
          errorMessage = error.error.errors.messages[0];
        } else {
          errorMessage = error.error.errors;
        }
        this.sharedService.showErrorMessage(errorMessage, "single");
      }
    }
  }
}
